import { useMemo } from 'react';

import { PERMISSIONS, usePlatformAuthorization } from '@/lib/auth';

export const useBroadcastSchedulePermissions = () => {
  const { hasPlatformPermission } = usePlatformAuthorization();

  const { canCreate, canUpdate, canUpdateInterval, canDelete } = useMemo(
    () => ({
      canCreate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_PROGRAM_BROADCAST]),
      canUpdate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_PROGRAM_BROADCAST]),
      canUpdateInterval: hasPlatformPermission([
        PERMISSIONS.MEDIA_MANAGER.UPDATE_PROGRAM_BROADCAST_INTERVAL,
      ]),
      canDelete: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.DELETE_PROGRAM_BROADCAST]),
    }),
    [hasPlatformPermission]
  );

  return {
    canCreate,
    canUpdate,
    canUpdateInterval,
    canDelete,
  };
};
